import React from 'react'
import { symbols } from '../../assets/assets'
import './Vector3.css'

function Vector3() {
  return (
    <>
    <img className="vector3" src={symbols.Vector3}></img>
    </>
  )
}

export default Vector3